import { compose, withState } from 'recompose';
import BlogPostView from './presenter';
import preload from './preload';

export default compose(
    withState('posts', 'setPosts'),
    preload()
)( BlogPostView );